import { useState, useEffect } from 'react';
import moment from 'moment';
import { IAttendAchievementError } from './interface';
import { getAttendAchievementError, getAttendAchievementErrorV3 } from './api';
import { useStaffsSelectBoxForOrgCodeOptions } from 'hooks/useStaffsOptions';

const useAchievementErrorState = () => {
  const loginUserOrgCode = sessionStorage.getItem('attendError.orgCode') || sessionStorage.getItem('loginUser.orgCode') || '';
  const now = new Date();
  const site: string | null = sessionStorage.getItem('loginUser.site'); 

  let dateFrom = new Date(now.getFullYear(), now.getMonth(), 1); // get first date
  let dateTo = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59); // get last date

  let targetDateFromStr = sessionStorage.getItem('attendError.targetDateFrom');
  let targetDateToStr = sessionStorage.getItem('attendError.targetDateTo');
  let isFilterStr = sessionStorage.getItem('attendError.isFilter') || "true";
  if(targetDateFromStr && targetDateToStr){
    dateFrom = moment(targetDateFromStr).toDate();
    dateTo = moment(targetDateToStr).toDate();
  }
  const [targetDateFrom, setTargetDateFrom] = useState<Date>(sessionStorage.getItem('attendError.directFromPopupAlert') === 'true' ? new Date(sessionStorage.getItem('loginUser.alertErrorStartDate') || "") : dateFrom);
  const [targetDateTo, setTargetDateTo] = useState<Date>(sessionStorage.getItem('attendError.directFromPopupAlert') === 'true' ? new Date(sessionStorage.getItem('loginUser.alertErrorEndDate') || "") : dateTo);
  const [orgCode, setOrgCode] = useState<string>(loginUserOrgCode);
  const [staffCode, setStaffCode] = useState(
    sessionStorage.getItem('attendError.staffCode')
    || (Number(site) === 1 && sessionStorage.getItem('loginUser.staffCode'))
    ||"");
  const staffsForOrgCodeOptions = useStaffsSelectBoxForOrgCodeOptions(orgCode, true);
  const [firstLoadStaff, setFirstLoadStaff] = useState<boolean>(false);
  const [isFilter, setIsFilter] = useState<boolean>(isFilterStr === "true" ? true : false);
  const [errorList, setErrorList] = useState<IAttendAchievementError[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  let isOtStr = sessionStorage.getItem('dataError.OT') || "true";
  const [isOT, setOT] = useState<boolean>(isOtStr === "true" ? true : false);
  let isHolidayWorkStr = sessionStorage.getItem('dataError.HolidayWork') || "true";
  const [isHolidayWork, setHolidayWork] = useState<boolean>(isHolidayWorkStr === "true" ? true : false);
  let isBreakStr = sessionStorage.getItem('dataError.Break') || "true";
  const [isBreak, setBreak] = useState<boolean>(isBreakStr === "true" ? true : false);
  let isWorkingTogetherStr = sessionStorage.getItem('dataError.WorkingTogether') || "true";
  const [isWorkingTogether, setWorkingTogether] = useState<boolean>(isWorkingTogetherStr === "true" ? true : false);
  let isUnder18Str = sessionStorage.getItem('dataError.Under18') || "true";
  const [isUnder18, setUnder18] = useState<boolean>(isUnder18Str === "true" ? true : false);
  let isForeignerStr = sessionStorage.getItem('dataError.Foreigner') || "true";
  const [isForeigner, setForeigner] = useState<boolean>(isForeignerStr === "true" ? true : false);

  useEffect(() => {
    return () => {
      sessionStorage.removeItem('attendError.staffCode');
      sessionStorage.removeItem('attendError.directFromPopupAlert');
    }
  }, [])
  const fetchData = async () => {
    setIsLoading(true);
    
    //if(!targetDateFromStr || !targetDateToStr){
      targetDateFromStr = moment(targetDateFrom).format('YYYY-MM-DD');
      targetDateToStr = moment(targetDateTo).format('YYYY-MM-DD');
      sessionStorage.setItem('attendError.targetDateFrom', targetDateFromStr);
      sessionStorage.setItem('attendError.targetDateTo', targetDateToStr);
    //}
    setErrorList([]);
    const achievementErrors = await getAttendAchievementErrorV3(
      staffCode,
      orgCode || '',
      targetDateFromStr,
      targetDateToStr,
      isFilter ? 0 : 1,
      isOT,
      isHolidayWork,
      isBreak,
      isWorkingTogether,
      isUnder18,
      isForeigner
    );
    setErrorList(achievementErrors);
    setIsLoading(false);
  };

  useEffect(() => {
    setFirstLoadStaff(true);
    if(staffsForOrgCodeOptions.filter((item: any) => item.value === staffCode).length === 0 && firstLoadStaff){
      setStaffCode('');
    }
  }, [staffsForOrgCodeOptions])

  return {
    targetDateFrom,
    setTargetDateFrom,
    targetDateTo,
    setTargetDateTo,
    orgCode,
    setOrgCode,
    isFilter,
    setIsFilter,
    errorList,
    setErrorList,
    isLoading,
    setIsLoading,
    fetchData,
    isOT,
    setOT,
    isHolidayWork,
    setHolidayWork,
    isBreak,
    setBreak,
    isWorkingTogether,
    setWorkingTogether,
    isUnder18,
    setUnder18,
    isForeigner,
    setForeigner,
    staffsForOrgCodeOptions,
    staffCode,
    setStaffCode,
    site
  };
};

export default useAchievementErrorState;
